(function ($) {
	/**
	 * Apply custom select styles
	 */
	$('.custom-select').select2({
		minimumResultsForSearch: Infinity,
	});
})(jQuery);
